import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './components/styles/ThemeContext';
import { MobilePage } from './pages/MobilePage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <ThemeProvider data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/step-flow" element={<MobilePage variant="step-flow" data-id="element-4" />} data-id="element-3" />
          <Route path="/quick-nav" element={<MobilePage variant="quick-nav" data-id="element-6" />} data-id="element-5" />
          <Route path="/overview" element={<MobilePage variant="overview" data-id="element-8" />} data-id="element-7" />
          <Route path="*" element={<Navigate to="/step-flow" replace data-id="element-10" />} data-id="element-9" />
        </Routes>
      </ThemeProvider>
    </BrowserRouter>;
}